import { supabase } from '../supabaseClient';

export const debugUserOperations = async () => {
  console.log('=== Debug User Operations ===');
  
  try {
    // Test 1: Check admin status
    console.log('1. Checking admin status...');
    const { data: adminStatus, error: adminError } = await supabase.rpc('is_admin_user');
    console.log('Admin status:', adminStatus, adminError);
    
    // Test 2: Get current user
    console.log('2. Getting current user...');
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    console.log('Current user:', user?.email, userError);
    
    // Test 3: Try to read user_profiles
    console.log('3. Reading user_profiles...');
    const { data: profiles, error: profilesError } = await supabase
      .from('user_profiles')
      .select('*')
      .limit(5);
    console.log('User profiles:', profiles?.length, 'records', profilesError);
    
    // Test 4: Try to read subscription_tiers
    console.log('4. Reading subscription_tiers...');
    const { data: tiers, error: tiersError } = await supabase
      .from('subscription_tiers')
      .select('*')
      .limit(5);
    console.log('Subscription tiers:', tiers?.length, 'records', tiersError);
    
    // Test 5: Try to update a user (this might fail due to RLS)
    if (profiles && profiles.length > 0) {
      console.log('5. Testing user update...');
      const testUser = profiles[0];
      const { data: updateResult, error: updateError } = await supabase
        .from('user_profiles')
        .update({ 
          updated_at: new Date().toISOString(),
          first_name: testUser.first_name // Keep the same value
        })
        .eq('user_id', testUser.user_id);
      console.log('Update result:', updateResult, updateError);
    }
    
  } catch (error) {
    console.error('Debug operation failed:', error);
  }
  
  console.log('=== End Debug ===');
};

// Call this function in the browser console or add it to a component
window.debugUserOperations = debugUserOperations;
